import Vue from "vue";
import VueApexCharts from 'vue-apexcharts';

export const colorsDonutChart = ['#FF84B0', '#60A9FF', '#FFB896', '#C69BF1', '#93D5DE', '#FFED4E', '#84D3FF', '#D0BEAA', '#8DE69D'];

Vue.use(VueApexCharts);

Vue.component('ApexChart', VueApexCharts);
